export default class Goal {
  // From the `SleepGoal(Enum)` class in the backend service.
  static map = {
    SLEEP_CONSISTENCY: {
      index: 0,
      name: 'More consistent sleep',
      text: 'sleep more consistently',
    },
    PHASE_ADVANCE: {
      index: 1,
      name: 'Sleep earlier',
      text: 'shift my sleep earlier',
    },
    PHASE_DELAY: {
      index: 2,
      name: 'Sleep later',
      text: 'shift my sleep later',
    },
    INCREASE_DURATION: {
      index: 3,
      name: 'Sleep longer',
      text: 'spend more time asleep',
    },
    INCREASE_QUALITY: {
      index: 4,
      name: 'Better quality sleep',
      text: 'have better quality sleep',
    },
  }

  // Given a key name in `Goal.map`, return the index.
  static keyToIndex(keyString) {
    let result = null
    Object.entries(Goal.map).find(([key, value]) => {
      if (key === keyString) {
        result = value.index
        return true
      }
    })
    return result
  }

  // Given an index return the key in `Goal.map`.
  static indexToKey(index) {
    if (index !== 0 && !index) return null
    let result = null
    Object.entries(Goal.map).find(([key, value]) => {
      if (value.index === index) {
        result = key
        return true
      }
    })
    return result
  }

  // Given an index, return the corresponding text.
  static indexToText(index, firstPerson = true) {
    if (index !== 0 && !index) return null
    const result = Object.values(Goal.map).find(value => {
      return value.index === index
    }).text
    if (firstPerson) {
      return result
    } else {
      return result.replace('my', 'your')
    }
  }
}